jQuery(document).ready(function () {
    jQuery('.privacy-title').click(function (e) {
        e.preventDefault();

        var question = jQuery(this);
        var answer = question.next();

        question.toggleClass('open');
        answer.stop().slideToggle(300);
    });
});
